import { render, staticRenderFns } from "./cardHeader.vue?vue&type=template&id=0fd38d2e&scoped=true"
import script from "./cardHeader.vue?vue&type=script&lang=js"
export * from "./cardHeader.vue?vue&type=script&lang=js"
import style0 from "./cardHeader.vue?vue&type=style&index=0&id=0fd38d2e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd38d2e",
  null
  
)

export default component.exports